import { DateTime } from 'luxon';

/**
 * One entry in the event log, as GET /events and an alert's timeline serve it.
 *
 * The server writes the sentence (`text`) so every surface words an event the
 * same way. `tone` is a status name ("Emergency"), coloured by that status, or
 * one of success, warning, error, accent and muted.
 *
 * Named ActivityEvent rather than Event, which the browser already defines.
 */
export default class ActivityEvent {
  static thaw(obj) {
    if (obj == null) return null;
    const event = new ActivityEvent();
    event.id = obj.id ?? null;
    event.type = obj.type ?? null;
    event.timestamp = obj.timestamp ? DateTime.fromISO(obj.timestamp) : null;
    event.isDrill = obj.isDrill === true;
    event.alertUpdateId = obj.alertUpdateId ?? null;
    event.status = obj.status ?? null;
    event.text = obj.text ?? '';
    event.tone = obj.tone ?? 'muted';
    return event;
  }

  static thawList(list) {
    return (list ?? []).map((obj) => ActivityEvent.thaw(obj));
  }

  getID() {
    return this.id;
  }

  getType() {
    return this.type;
  }

  getTimestamp() {
    return this.timestamp;
  }

  getIsDrill() {
    return this.isDrill;
  }

  /** The alert this event belongs to, when it is a status change. */
  getAlertUpdateID() {
    return this.alertUpdateId;
  }

  getText() {
    return this.text;
  }

  getTone() {
    return this.tone;
  }
}
